<template>
  <footer class="footer">
    <div class="footer-container" :style="{ padding: '0 ' + sidePadding + 'px' }">
      <!-- 上半部分：logo + nav + 语言选择 -->
      <div class="footer-top-row">
        <div class="footer-logo">
          <img :src="defaultLogo" alt="Logo" />
        </div>

        <nav class="footer-nav">
          <div style="cursor: pointer;" @click="handleMenuClick( { label: 'TITIAN®', path: '/productDetail' },0)">Products</div>
          <span>|</span>
          <div style="cursor: pointer;" @click="handleMenuClick( { label: 'TITIAN®', path: '/about' },1)">Company</div>
          <!-- <span>|</span>
          <div>Contact Us</div>-->
          <span>|</span>
          <div style="cursor: pointer;" @click="handleMenuClick( { label: 'TITIAN®', path: '/privacyPolicy' },2)">Privacy Policy</div>
          <span>|</span>

          <!-- 语言选择 -->
          <div class="lang-wrapper">
            <img src="@/assets/images/home/language.png" alt="Language" class="lang-icon" />
            <select v-model="selectedLang" @change="changeLanguage" class="lang-select">
              <option value="en">EN</option>
              <!-- <option value="zh">中文</option>
              <option value="jp">日本語</option> -->
            </select>
          </div>
        </nav>
      </div>

      <!-- 下半部分：文字 + 二维码 -->
      <div class="footer-bottom-row">
        <div class="footer-bottom">{{ $t('message.footerCopyRight') }} <a style="color:inherit" href="https://beian.miit.gov.cn" target="blank">{{ $t('message.footerCopyRightRecNum') }}</a> </div>
        <div class="footer-qr">
          <img src="@/assets/images/home/qrCode.png" alt="QR Code" />
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      selectedLang: 'en',
      defaultLogo: require('@/assets/images/home/headerTitle_logo.png'),
      sidePadding: 0
    }
  },
  mounted() {
    this.updatePadding()
    window.addEventListener('resize', this.updatePadding)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updatePadding)
  },
  methods: {
  handleMenuClick(item, index) {
    if (!item.path) return;

    if (this.$route.path !== item.path) {
      // 跳转到新页面
      this.$router.push(item.path);
    } else {
      // 当前页：滚动到顶部
      window.scrollTo({
        top: 0,
        behavior: 'smooth' // 平滑滚动
      });

      // 可选：如果你有 header 菜单高亮逻辑
      if (this.$refs.homeHeader) {
        this.$refs.homeHeader.selectedMenu = index;
      }
    }
  },

    changeLanguage() {
      console.log('切换语言为：', this.selectedLang)
    },
    updatePadding() {
      if (window.innerWidth <= 768) {
        this.sidePadding = 5
      } else {
        // 左右间距 = 屏幕宽度的 18%
        this.sidePadding = window.innerWidth * 0.18
      }
    }
  }
}
</script>

<style scoped>
.footer {
  background-color: #04132c;
  color: #fff;
  font-size: var(--footer-size);
  border-top: 1px solid #474747;
}

/* 容器居中 */
.footer-container {
  /* max-width: 2100px; */
  margin: 0 auto;
  /* width: 100%; */
}

/* 上半部分 */
.footer-top-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  flex-wrap: wrap;
  gap: 20px;
  border-bottom: 1px solid #474747;
}

.footer-logo img {
  height: 40px;
  cursor: pointer;
}

.footer-nav {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

/* 小屏幕调整 gap */
@media screen and (max-width: 768px) {
  .footer-nav {
    gap: 12px; /* 根据需求调整 */
    font-size: 1rem;
  }
}
.footer-nav a {
  color: inherit;
  text-decoration: none;
}

.footer-nav span {
  color: rgba(255, 255, 255, 0.3);
}

/* 语言选择 */
.lang-wrapper {
  display: flex;
  align-items: center;
  gap: 5px;
}

.lang-icon {
  width: 16px;
  height: 16px;
  object-fit: contain;
}

.lang-select {
  background-color: inherit;
  color: inherit;
  border: 1px solid rgba(255, 255, 255, 0.3);
  padding: 2px 6px;
  border-radius: 4px;
  cursor: pointer;
  font-size: var(--footer-size);
}

/* 下拉展开的选项样式（大部分浏览器有效） */
.lang-select option {
  background-color: #04132c; /* 深色背景 */
  color: #fff; /* 白色文字 */
}

/* 下半部分 */
.footer-bottom-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
  flex-wrap: wrap;
  gap: 20px;
  font-size: var(--footer-sub-size);
}

.footer-bottom {
  /* font-size: 12px; */
  color: rgba(255, 255, 255, 0.7);
  flex: 1;
  line-height: 1.6;
}

.footer-qr img {
  height: 60px;
}

/* 响应式 */
@media screen and (max-width: 768px) {
  /* .footer-container {
    padding: 0 20px;
  } */
  .footer-top-row {
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding:3rem 0;
  }
  .footer-logo img{
    height: 30px;
  }
  .footer{
    background-color:#000;
    border-top: none;
  }
  .footer-bottom-row {
    gap: 10px;
    padding: 20px 10px;
    font-size: 1rem;
  }
}
</style>
